import React from 'react';
import cn from 'clsx';
import PropTypes from 'prop-types';

import {
  CarBumpRegularIcon,
  SteeringWheelRegularIcon,
  VolumeRegularIcon
} from '../../shared/icons/icons';
import TreadwellBarRow, {
  TreadwellBarRowColor
} from '../treadwell-bar-row/treadwell-bar-row';

import { AEM_CONTENT_IDS } from '../../shared/constants/cms';

import styles from './ride-data-info.scss';

function RideDataInfo(props) {
  const {
    aemTooltipsContent,
    className = '',
    comfort,
    handling,
    quiet
  } = props;
  const handlingContent =
    aemTooltipsContent?.[AEM_CONTENT_IDS.handlingSteeringResponse];
  const comfortContent = aemTooltipsContent?.[AEM_CONTENT_IDS.comfort];
  const noiseContent = aemTooltipsContent?.[AEM_CONTENT_IDS.noiseLevel];

  const charts = [
    {
      icon: SteeringWheelRegularIcon,
      maxRatingLabel: 'high',
      minRatingLabel: 'low',
      title: handlingContent?.title || 'Handling (Steering Response)',
      tooltip: handlingContent?.tipText,
      value: handling
    },
    {
      icon: CarBumpRegularIcon,
      maxRatingLabel: 'smooth',
      minRatingLabel: 'rough',
      title: comfortContent?.title || 'Comfort',
      tooltip: comfortContent?.tipText,
      value: comfort
    },
    {
      icon: VolumeRegularIcon,
      maxRatingLabel: 'quiet',
      minRatingLabel: 'loud',
      title: noiseContent?.title || 'Noise Level',
      tooltip: noiseContent?.tipText,
      value: quiet
    }
  ];

  return (
    <div className={cn(styles['container'], className)}>
      {charts.map((chart, i) => (
        <TreadwellBarRow
          barColor={TreadwellBarRowColor.GREY_BLUE}
          key={`chart-${i}`}
          {...chart}
        />
      ))}
    </div>
  );
}

RideDataInfo.propTypes = {
  aemTooltipsContent: PropTypes.object,
  className: PropTypes.string,
  comfort: PropTypes.number,
  handling: PropTypes.number,
  quiet: PropTypes.number
};

export default RideDataInfo;
